import styled, { css } from 'styled-components'
import Typography from 'builder/styles/typography'
import Media from 'builder/styles/media'
import { foldableSectionMixin } from '../Section'
import { Colors, Spacing } from 'cio-design-library/design-tokens'

const foldableSectionMixinNoBorderRadiusOnBottom = css`
  background-color: ${Colors.White};
  border-radius: ${Spacing.XS} ${Spacing.XS} 0 0;
`

export const Container = styled.div(props => {
  const { noBorderRadiusOnBottom } = props

  return css`
    margin-bottom: 40px;
    ${noBorderRadiusOnBottom ? foldableSectionMixinNoBorderRadiusOnBottom : foldableSectionMixin};
    position: relative;
    padding: 20px 36px;
    ${Media.Phone`
    padding: 21px 20px;
  `};
  `
})

export const SectionTitle = styled.div`
  ${Typography.Subhead}
  font-weight: 600;
  margin-bottom: 12px;
`

export const SectionContent = styled.div``
